import { makeStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import React from 'react';

import CarouselItems from './CarouselItems';
import type { CarouselSlideProps } from './types/CarouselSlideProps';

const useStyles = makeStyles((theme) =>
    createStyles({
        carouselSlideItems: {
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            paddingTop: '38px',
            paddingBottom: '28px',
            paddingRight: '32px',
            marginLeft: '54px',
        },
        fullLeftBgImageContainer: {
            flexShrink: 0,
            display: 'flex',
            justifyContent: 'flex-start',
            width: '360px',
        },
        fullLeftImage: {
            maxWidth: '100%',
            overflow: 'clip',
        },
        '@media all and (max-width: 1350px)': { fullLeftBgImageContainer: { display: 'none' } },
    }),
);

const CarouselSlideFullLeftImageStyle = ({
    lineImage,
    title,
    description,
    backgroundImage,
    buttonText,
    buttonRedirectUrl,
    buttonType,
    setOpen,
    idx,
    currSlide,
}: CarouselSlideProps) => {
    const classes = useStyles();
    return (
        <div
            style={{
                display: 'flex',
                width: '100%',
                height: '100%',
            }}
            data-cy={`carousel-slide-${idx}`}
        >
            {backgroundImage && <div
                className={classes.fullLeftBgImageContainer}
                data-cy={`bottom-right-img-${idx}`}
            >
                <img
                    alt="" // decorative image no alt text needed
                    src={backgroundImage}
                    className={classes.fullLeftImage}
                />
            </div> }
            <div
                className={classes.carouselSlideItems}
                data-cy={`carousel-items-primary-${idx}`}>
                <CarouselItems
                    title={title}
                    description={description}
                    lineImage={lineImage}
                    buttonText={buttonText}
                    buttonType={buttonType}
                    buttonRedirectUrl={buttonRedirectUrl}
                    idx={idx}
                    currSlide={currSlide}
                    setOpen={setOpen}
                />
            </div>
        </div>
    );
};

export default CarouselSlideFullLeftImageStyle;
